export interface BibliographySetManagementInfoUpdateRequest {
  id: number
  bibliographySetId: number
  continuation: string
  notArrived: string
  openBookbinding: string
  bookClaim: string
  shelfPlace: string
  traderCode: string
  donorCode: string
  missingNumberText: string
  retitleBefore: string
  retitleAfter: string
  contractYear: string
  holdingYear: string
  holdingVolume: string
  needBookbinding: string
  memo1: string
  memo2: string
  memo3: string
  memo4: string
  memo5: string
  memo6: string
  memo7: string
  revision: number
}

export function BibliographySetManagementInfoUpdateRequestToJSON(
  value: BibliographySetManagementInfoUpdateRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    bibliography_set_id:
      value.bibliographySetId !== 0 ? value.bibliographySetId : undefined,
    continuation: value.continuation !== '' ? value.continuation : undefined,
    not_arrived: value.notArrived !== '' ? value.notArrived : undefined,
    open_bookbinding:
      value.openBookbinding !== '' ? value.openBookbinding : undefined,
    book_claim: value.bookClaim !== '' ? value.bookClaim : undefined,
    shelf_place: value.shelfPlace !== '' ? value.shelfPlace : undefined,
    trader_code: value.traderCode !== '' ? value.traderCode : undefined,
    donor_code: value.donorCode !== '' ? value.donorCode : undefined,
    missing_number_text:
      value.missingNumberText !== '' ? value.missingNumberText : undefined,
    retitle_before:
      value.retitleBefore !== '' ? value.retitleBefore : undefined,
    retitle_after: value.retitleAfter !== '' ? value.retitleAfter : undefined,
    contract_year: value.contractYear !== '' ? value.contractYear : undefined,
    holding_year: value.holdingYear !== '' ? value.holdingYear : undefined,
    holding_volume:
      value.holdingVolume !== '' ? value.holdingVolume : undefined,
    need_bookbinding:
      value.needBookbinding !== '' ? value.needBookbinding : undefined,
    memo1: value.memo1 !== '' ? value.memo1 : undefined,
    memo2: value.memo2 !== '' ? value.memo2 : undefined,
    memo3: value.memo3 !== '' ? value.memo3 : undefined,
    memo4: value.memo4 !== '' ? value.memo4 : undefined,
    memo5: value.memo5 !== '' ? value.memo5 : undefined,
    memo6: value.memo6 !== '' ? value.memo6 : undefined,
    memo7: value.memo7 !== '' ? value.memo7 : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
